import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f23d0c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Comunicazione", -1))
const _hoisted_2 = { class: "title text-input input-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Titolo della comunicazione", -1))
const _hoisted_4 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_5 = { class: "subtitle text-input input-content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "subtitle" }, "Sottotitolo della comunicazione", -1))
const _hoisted_7 = { class: "editing-space cursor-text title text-input input-content" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "text" }, "Testo della comunicazione", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!

  return (_openBlock(), _createBlock(_component_ModalDialog, null, {
    h1: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_ctx.titleText), 1)
    ]),
    h3: _withCtx(() => [
      _hoisted_1
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_PrimaryButton, {
        class: "button bg-white text-primary-900 undo",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClose()))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Annulla")
        ]),
        _: 1
      }),
      _createVNode(_component_PrimaryButton, {
        class: "button bg-primary-900 text-white",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onConfirm()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.actionText), 1)
        ]),
        _: 1
      }),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_Loader, {
            key: 0,
            message: "Salvataggio..."
          }))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _withDirectives(_createElementVNode("input", {
          class: _normalizeClass(["bg-primary-50 border-red-400", { border: _ctx.v$.title.$error }]),
          id: "title",
          type: "text",
          placeholder: "Inserisci il titolo della comunicazione",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.title) = $event)),
          onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.v$.title.$touch && _ctx.v$.title.$touch(...args)))
        }, null, 34), [
          [_vModelText, _ctx.title]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.title.$errors, (error) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "errors",
            key: error.$uid
          }, [
            (error.$validator == 'required')
              ? (_openBlock(), _createElementBlock("label", _hoisted_4, "È necessario inserire il titlo della comunicazione"))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          class: "bg-primary-50 border-red-400",
          id: "subtitle",
          type: "text",
          placeholder: "Inserisci il sottotitolo della comunicazione",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.subtitle) = $event))
        }, null, 512), [
          [_vModelText, _ctx.subtitle]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createElementVNode("textarea", {
          class: "bg-primary-50 p-4 pt-2 input-text",
          placeholder: "Inserisci il testo della comunicazione",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.description) = $event)),
          onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('update'))),
          onKeyup: _cache[7] || (_cache[7] = _withKeys(($event: any) => (_ctx.$emit('update')), ["enter"])),
          rows: "10"
        }, null, 544), [
          [_vModelText, _ctx.description]
        ])
      ])
    ]),
    _: 1
  }))
}